import { render, staticRenderFns } from "./google-autocomplete.vue?vue&type=template&id=b5d2eb4e&"
import script from "./google-autocomplete.vue?vue&type=script&lang=js&"
export * from "./google-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports